
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DropDownIcon, DropDownOption } from '../../../../../../shared/ui/src/lib/shared/elements/drop-down/drop-down.component';
import { Auth, BaseCmsComponent, CmsComponent, CmsLinkComponent, LinkRef } from '@kion/data-models';
import { Observable } from 'rxjs';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import { map, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AuthsFacade } from '@kion/data-access/data-access-auths';
import {CmsConfig} from "../../config/cms.config";
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-cms-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnDestroy {

  @Input() component: BaseCmsComponent;

  private readonly subSink: SubSink;

  links$: Observable<DropDownOption[]>;
  icon: DropDownIcon = {
    icon: 'assets/icons/platform_header_account_icon.svg',
    title: 'platform_header_account_icon',
    alt: 'platform_header_account_icon'
  };

  constructor(
    private cmsComponentsFacade: CmsComponentsFacade,
    private translateService: TranslateService,
    private authsFacade: AuthsFacade,
    private cmsConfig:CmsConfig
  ) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    const links = (this.component as CmsComponent).links?.split(' ') || [];
    const auth$ = this.authsFacade.all$.pipe(
      map(
        (auth: Auth[]) => auth[0]
      )
    );
    this.cmsComponentsFacade.loadByIds(links, links.join('_'));
    this.links$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (linkComponents: CmsComponent[]) => linkComponents
          .filter(link => links.includes(link.uid)).sort(
            (a, b) => {
              const indexA = links.indexOf(a.uid);
              const indexB = links.indexOf(b.uid);
              return indexA < indexB ? -1 : 1;
            }
          ) as CmsLinkComponent[]),
      map(
        (components: CmsLinkComponent[]) => {
          const array = components.map(
            (component: CmsLinkComponent) => {
              return {
                key: "link",
                value: component.linkName,
                selected: false,
                linkRef: component as unknown as LinkRef
              }
            }
          );
          this.subSink.sink = auth$.pipe(take(1)).subscribe(
            auth => {
              if (auth?.user) {
                array.push(
                  {
                    key: "link",
                    value: this.translateService.instant("account.link.signOut"),
                    selected: false,
                    linkRef: {
                      url: 'sign-out'
                    }
                  }
                );
              }
              if (!auth?.user && this.cmsConfig.project==="LR") {
                array.push(
                  {
                    key: "link",
                    value: this.translateService.instant("signUp.button.continue"),
                    selected: false,
                    linkRef: {
                      url: 'auth',
                      external: "true"
                    }
                  },
                  {
                    key: "link",
                    value: this.translateService.instant("checkout.spread.button.signIn"),
                    selected: false,
                    linkRef: {
                      url: 'auth',
                      external: "true"
                    }
                  }
                );
              }
            }
          );
          return array;
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
